import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const WOODCHAINCUSTODY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.WoodChainCustody.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('certificationType', 'Entity.WoodChainCustody.CertificationType')
    .required()
    .minLength(1)
    .maxLength(6)
    .build(),
  FieldBuilder
    .checkbox('isCertified', 'Entity.WoodChainCustody.IsCertified')
    .build(),
  FieldBuilder
    .date('expirationDate', 'Entity.WoodChainCustody.ExpirationDate')
    .required()
    .build(),
];

export const WOODCHAINCUSTODY_CONFIG = {
  entityName: 'WoodChainCustody',
  localizationKey: 'Planning::Entity.WoodChainCustody',
  fields: WOODCHAINCUSTODY_FIELDS,
  permission: 'PlanningCertification.WoodChainCustodies',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Certification + MENU_NAME_SUFFIX,
};
